import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
    container: {
        marginBottom: theme.spacing(4),
        padding: theme.spacing(1),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(2),
        },
    },
    backButton: {
        marginBottom: theme.spacing(1),
        fontSize: '0.875rem',
        [theme.breakpoints.down("sm")]: {
            fontSize: '0.75rem',
            padding: theme.spacing(0.5, 1),
        },
    },
    headerCard: {
        marginBottom: theme.spacing(3),
    },
    detailsGrid: {
        marginBottom: theme.spacing(1),
    },
    heading: {
        fontWeight: 500,
        marginBottom: theme.spacing(2),
        fontSize: '1.25rem',
        [theme.breakpoints.down("sm")]: {
            fontSize: '1.1rem',
        },
    },
    labelText: {
        color: theme.palette.text.secondary,
        fontWeight: 500,
    },
    valueText: {
        fontWeight: 400,
    },
    detailLabel: {
        fontWeight: 500,
    },
    totalsSection: {
        marginTop: theme.spacing(2),
        paddingTop: theme.spacing(2),
    },
    totalAmount: {
        fontWeight: 700,
        fontSize: "1.1rem",
    },
    lineItemsContainer: {
        marginTop: theme.spacing(1),
    },
    lineItemsHeader: {
        backgroundColor: theme.palette.background.default,
        fontWeight: 700,
        padding: theme.spacing(1.5),
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
            '& .MuiTypography-subtitle2': {
                fontSize: '0.75rem',
            },
        },
    },
    rightAligned: {
        textAlign: "right",
        [theme.breakpoints.down("sm")]: {
            textAlign: "center",
        },
    },
    statusBox: {
        display: "inline-block",
        padding: theme.spacing(0.5, 1.5),
        borderRadius: theme.shape.borderRadius,
        color: "white",
        backgroundColor: theme.palette.warning.main,
    },
    full: {
        "& > *": {
            borderBottom: "unset",
            backgroundColor: theme.palette.custom.indicator.full,
        },
    },
    partial: {
        "& > *": {
            borderBottom: "unset",
            backgroundColor: theme.palette.custom.indicator.partial,
        },
    },
    none: {
        "& > *": {
            borderBottom: "unset",
            backgroundColor: theme.palette.custom.indicator.none,
        },
    },
    warn: {
        "& > *": {
            borderBottom: "unset",
            backgroundColor: theme.palette.custom.indicator.warn,
        },
    },
    over: {
        "& > *": {
            borderBottom: "unset",
            backgroundColor: theme.palette.custom.indicator.over,
        },
    },
    mismatch: {
        "& > *": {
            borderBottom: "unset",
            backgroundColor: theme.palette.custom.indicator.mismatch,
        },
    },
    fullBorder: {
        border: 0,
        borderStyle: "solid",
        borderColor: theme.palette.custom.border.full,
        borderLeftWidth: 2,
    },
    partialBorder: {
        border: 0,
        borderStyle: "solid",
        borderColor: theme.palette.custom.border.partial,
        borderLeftWidth: 2,
    },
    noneBorder: {
        border: 0,
        borderStyle: "solid",
        borderColor: theme.palette.custom.border.none,
        borderLeftWidth: 2,
    },
    warnBorder: {
        border: 0,
        borderStyle: "solid",
        borderColor: theme.palette.custom.border.warn,
        borderLeftWidth: 2,
    },
    overBorder: {
        border: 0,
        borderStyle: "solid",
        borderColor: theme.palette.custom.border.over,
        borderLeftWidth: 2,
    },
        mismatchBorder: {
        border: 0,
        borderStyle: "solid",
        borderColor: theme.palette.custom.border.mismatch,
        borderLeftWidth: 2,
    },
    mobileBottomActions: {
        [theme.breakpoints.down("sm")]: {
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: theme.spacing(2),
            '& .MuiButton-root': {
                width: '100%',
            },
            '& .MuiTypography-body2': {
                textAlign: 'center',
                fontSize: '0.875rem',
            },
        },
    },
    barcodeSection: {
        [theme.breakpoints.down("sm")]: {
            '& .MuiGrid2-root': {
                marginBottom: theme.spacing(1),
            },
        },
    }
}));